import React, { useEffect, useState } from "react";
import BarChart from "../../components/common/BarChart";
import PieChart from "../../components/common/PieChart";
import money from "../../assets/images/money.png";
import city from "../../assets/images/city.png";
import pin from "../../assets/images/pin.png";
import shopping from "../../assets/images/shopping.png";
import Constants from "../../utils/Constants";
import axios from "axios";
import SplashScreen from "../../components/loader/SplashScreen/SplashScreen";
import { useQuery } from "@tanstack/react-query";
import NotFound from "../../components/common/Notfound";
import { DecryptData } from "../../utils/Cipher";

const Dashboard = () => {
  const [activeBtn, setActiveBtn] = useState("All");
  // const [Homedata, sethomedata] = useState(null);

  const [selectedName, setselectedname] = useState("Seal");
  const [selectedCity, setselectedCity] = useState("Ghizer");
  const [omsstatus, setstatus] = useState("incart");

  const HomeApi = () => {
    return axios({
      method: "get",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      url: Constants.url + "admin/home",
    }).then((res) => {
      // sethomedata(res.data.data);

      return res.data.data;
    });
  };

  // useEffect(() => {
  //   HomeApi();
  // }, []);

  //usequery for caching the data object so the network call isnt initiated everytime the page renders
  const { data: Homedata, isLoading } = useQuery({
    queryFn: () => HomeApi(),
    queryKey: ["Homedata"],
    staleTime: Infinity,
    // 1 Hour Cache Time
    cacheTime: 1000 * 60 * 60,
  });

  return (
    <>
      {!isLoading ? (
        <>
          <div className="dashboardWrp">
            <div className="uk-container uk-container-expand">



              {/* <div className="right uk-margin uk-flex uk-flex-right ">
                <div className="formInput uk-margin-right">
                  <label>Start Date</label>
                  <input type="date" className="uk-input" />
                </div>

                <div className="formInput uk-margin-right">
                  <label>End Date</label>

                  <input type="date" className="uk-input" />
                </div>
              </div> */}

              <div uk-grid="" className="uk-grid uk-grid-small">
                <div className="uk-width-1-1">
                  <div className="">
                    <div
                      className="uk-grid uk-grid-column-small uk-grid-row-large uk-child-width-1-4@s uk-text-center"
                      uk-grid
                      uk-height-match=".uk-card"
                    >
                      <div>
                        <h2 className="total">Total Sales</h2>
                        <div className="uk-card uk-card-default uk-card-body first">
                          <div className="imageone">
                            <img src={money} alt="" title="" className="" />
                          </div>
                          <div className="contentonefirst">
                            <span>Revenue</span>
                            <h2>
                              {Homedata ? Homedata.totalSales?.totalRevenue : 0}
                            </h2>
                            <span>Total Orders</span>
                            <h2>
                              {Homedata ? Homedata.totalSales?.totalOrders : 0}
                            </h2>
                          </div>
                        </div>
                      </div>

                      <div>
                        <h2 className="total">Total Sales (Split By Car)</h2>
                        <div className="uk-card uk-card-default uk-card-body">
                          <select
                            name="cars"
                            value={selectedName}
                            onChange={(e) => setselectedname(e.target.value)}
                          >
                            {Homedata?.totalSalesBy?.map((item) => (
                              <option key={item.name} value={item.name}>
                                {item.name}
                              </option>
                            ))}
                          </select>

                          <div className="imageone">
                            <img src={city} alt="" title="" className="" />
                          </div>

                          {selectedName && (
                            <div className="contentone">
                              <span>Revenue</span>
                              <h2>
                                {
                                  Homedata.totalSalesBy.find(
                                    (item) => item.name === selectedName
                                  )?.totalRevenue
                                }
                              </h2>
                              <span>Total Orders</span>
                              <h2>
                                {
                                  Homedata.totalSalesBy.find(
                                    (item) => item.name === selectedName
                                  )?.totalOrders
                                }
                              </h2>
                            </div>
                          )}
                        </div>
                      </div>

                      <div>
                        <h2 className="total">Total Sales (Split By City)</h2>
                        <div className="uk-card uk-card-default uk-card-body">
                          <select
                            name="city"
                            onChange={(e) => setselectedCity(e.target.value)}
                          >
                            {Homedata.totalSalesSplitByCity?.map((item) => (
                              <option key={item.name} value={item.name}>
                                {" "}
                                {item.name}{" "}
                              </option>
                            ))}
                          </select>

                          <div className="imageone">
                            <img src={pin} alt="" title="" className="" />
                          </div>

                          {selectedCity && (
                            <div className="contentone">
                              <span>Revenue</span>
                              <h2>
                                {
                                  Homedata.totalSalesSplitByCity.find(
                                    (item) => item.name === selectedCity
                                  )?.totalRevenue
                                }
                              </h2>
                              <span>Total Orders</span>
                              <h2>
                                {
                                  Homedata.totalSalesSplitByCity.find(
                                    (item) => item.name === selectedCity
                                  )?.totalOrders
                                }
                              </h2>
                            </div>
                          )}
                        </div>
                      </div>

                      <div>
                        <h2 className="total">OMS Status</h2>
                        <div className="uk-card uk-card-default uk-card-body">
                          <select
                            name="cars"
                            value={omsstatus}
                            onChange={(e) => setstatus(e.target.value)}
                          >
                            {Object.keys(Homedata.orderInProcess).map((key) => (
                              <option key={key} value={key}>
                                {key}
                              </option>
                            ))}
                          </select>

                          <div className="imageone">
                            <img src={shopping} alt="" title="" className="" />
                          </div>

                          <div className="omsone">
                            <p className="left">Count</p>
                            <h2 className="right">
                              {Homedata.orderInProcess[omsstatus]}
                            </h2>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      className="uk-grid uk-grid-column-small uk-grid-row-large uk-child-width-1-2@s uk-text-center"
                      uk-grid
                      uk-height-match=".uk-card"
                    >
                      <div>
                        <div className="uk-card uk-card-default uk-card-body graph">
                          <div className="graphone bar ">
                            <BarChart
                              bardata={
                                Homedata
                                  ? Homedata.testDriveCountByVariantObj
                                  : 0
                              }
                            />
                            {/* <p className="websiteview">Website View</p> */}
                            {/* <p>Last Campaign Performance</p> */}
                            {/* <hr></hr> */}
                            {/* <ul className="icon-list">
                              <li>
                                <span uk-icon="icon: clock"></span>Compaign sent
                                2 days ago
                              </li>
                            </ul> */}
                          </div>
                        </div>
                      </div>
                      <div>
                        <div className="uk-card uk-card-default uk-card-body graph">
                          <div className="graphone pie">
                            {/* props for pieChart */}
                            <PieChart
                              payProCount={
                                Homedata ? Homedata.pieChart.payProCount : 0
                              }
                              dealerCount={
                                Homedata ? Homedata.pieChart.dealerCount : 0
                              }
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* <div className="powered">
                      <p>
                        @2024, Powered By <b>Convex Interactive</b>
                      </p>
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      ) : (
        <SplashScreen />
      )}
    </>
  );
};

export default Dashboard;
